export default "__VITE_ASSET__DgO4JrnJ__"